import {BASE_SERVICE_URL} from '../lib/constants'

export default function (uid, sheetIndex, header) {
    return fetch(BASE_SERVICE_URL + `/${uid}/${sheetIndex}`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            header
        })
    }).then((response) => {
        if (response.ok) {
            return response.json()
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}
